import { data } from '@amazon/vinyl-observable'
import { globalRef, type Maybe } from '@amazon/vinyl-util'
import { mrnMediaType } from '@amzn/bf-playback'
import { toast } from '@/components/toast'
import { getStringAsync } from '@/playback/i18n/bundle.generated'
import { toastPlaybackFailed } from '@/playback/playbackNoticeToast'

export type PlayerSetupOutcome = 'pending' | 'ready' | 'failed'

const outcomeRef = globalRef(() => data<PlayerSetupOutcome>('pending'))

export function setPlayerSetupOutcome(outcome: PlayerSetupOutcome): void {
    outcomeRef.value.value = outcome
}

/** Toasts and returns true when the player failed to start, so the caller drops the command. */
export function reportPlaybackUnavailable(): boolean {
    if (outcomeRef.value.value !== 'failed') return false
    toast(getStringAsync('dmusic_playback_unexpected_error_toast'))
    return true
}

/** Like {@link reportPlaybackUnavailable} for a press that starts new content: the toast names it. */
export function reportPlayStartUnavailable(playParamsId: Maybe<string>): boolean {
    if (outcomeRef.value.value !== 'failed') return false
    toastPlaybackFailed(mrnMediaType(playParamsId))
    return true
}
